module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/new/gronk_text-914b7309a566b40d9170bacfc289aaa7.png";